module.exports = __webpack_public_path__ + "img/icons8-volkswagen.db3517b3.svg";